'use client';

import React, { useEffect, useRef } from 'react';

import mapboxgl from 'mapbox-gl';

import 'mapbox-gl/dist/mapbox-gl.css';

type TProps = {
  lat?: number;
  lng?: number;
  zoom?: number;
};

mapboxgl.accessToken = process.env.NEXT_PUBLIC_MAPBOX_API_TOKEN as string;

const Map = (props: TProps) => {
  const mapContainerRef = useRef(null);

  const { lat, lng, zoom = 14 } = props;

  useEffect(() => {
    if (!lng || !lat) {
      return;
    }

    const map = new mapboxgl.Map({
      container: mapContainerRef.current as any,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom,
    });

    // Create default markers
    new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map);

    // Clean up on unmount
    return () => map.remove();
  }, [lat, lng, zoom]);

  return (
    <div
      className="map-container"
      ref={mapContainerRef}
      style={{ height: '100%', width: '100%' }}
    />
  );
};

export default Map;
